/**
 * Maps a notification to its click destination. Pure — no router imports —
 * so it can be shared by the navbar dropdown and the toast layer.
 *
 * Returns { path, state? } or null when clicking should do nothing
 * (invites are handled by their Accept/Ignore buttons; unknown types no-op).
 */
export const getNotificationDestination = (notification, username) => {
    if (!notification) return null;
    const { notificationType, relatedClassroomId } = notification;

    switch (notificationType) {
        case 'announcement':
            return relatedClassroomId ? { path: `/my-classrooms/${relatedClassroomId}/a` } : null;
        case 'newAssignment':
            return relatedClassroomId ? { path: `/my-classrooms/${relatedClassroomId}/assignments` } : null;
        case 'feedback':
        case 'siteFeedback':
        case 'feedbackMessage':
            if (relatedClassroomId) {
                return { path: `/my-classrooms/${relatedClassroomId}/feedback` };
            }
            return username
                ? { path: `/user/${username}`, state: { activeTab: 'Feedback' } }
                : null;
        case 'acceptedInvite':
            return relatedClassroomId ? { path: `/my-classrooms/${relatedClassroomId}/p` } : null;
        case 'invite':
        default:
            return null;
    }
};

export default getNotificationDestination;
